import React from "react";
import { useForm } from "react-hook-form";
import { useSignUpContext } from "../../../context/signup/signupcontext";
import styles from "./UserRole.module.css"; // Import the CSS module

interface UserRoleProps {
  nextStep: () => void;
  prevStep: () => void;
}

const UserRole: React.FC<UserRoleProps> = ({ nextStep, prevStep }) => {
  const { setFormData, formData } = useSignUpContext();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      role: formData?.userRole?.role || "", // Get default role from formData
    },
  });

  // Watch the role selection
  const selectedRole = watch("role");

  // Optionally reset form data when navigating back
  React.useEffect(() => {
    reset(formData?.userRole);
  }, [reset, formData]);

  const onSubmit = (data: any) => {
    setFormData({ userRole: data }); // Update formData with the selected role
    nextStep(); // Move to the next step
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2>Welcome {formData?.demographics?.firstName}, are you the</h2>
      <div className={styles.roleSelection}>
        <label
          className={`${styles.roleButton} ${
            selectedRole === "landlord" ? styles.roleButtonActive : ""
          }`}
        >
          <input
            type="radio"
            value="landlord"
            {...register("role", { required: true })} // Register 'role' field
          />
          Landlord
        </label>

        <label
          className={`${styles.roleButton} ${
            selectedRole === "propertyManager" ? styles.roleButtonActive : ""
          }`}
        >
          <input
            type="radio"
            value="propertyManager"
            {...register("role", { required: true })} // Register 'role' field
          />
          Property Manager
        </label>
      </div>

      {errors.role && <p>This field is required</p>}

      <div className={styles.formActions}>
        <button type="button" className={styles.btn} onClick={prevStep}>
          Previous
        </button>
        <button type="submit" className={`${styles.btn} ${styles.primaryBtn}`}>
          Next
        </button>
      </div>
    </form>
  );
};

export default UserRole;
